
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#003653","fill-rule":"evenodd","d":"M22 7a1.75 1.75 0 011.741 1.577l.009.173v1.689c.417.29.7.758.744 1.292l.006.144.001 2.643A1.75 1.75 0 0126 16.25V20c0 .698-.408 1.3-1 1.581v1.669a1.75 1.75 0 01-1.606 1.744L23.25 25H8.375a2.375 2.375 0 01-2.37-2.212L6 22.625V9.375c0-1.257.977-2.286 2.212-2.37L8.375 7H22zm0 1H8.375c-.715 0-1.302.545-1.369 1.243L7 9.375v13.25c0 .715.545 1.302 1.243 1.369l.132.006H23.25a.75.75 0 00.743-.648L24 23.25v-1.5h-3.375a3.625 3.625 0 01-3.62-3.432L17 18.125a3.625 3.625 0 013.625-3.625H23.5v-2.625a.75.75 0 00-.648-.743l-.102-.007H10.586a1.963 1.963 0 01-1.805-1.001.5.5 0 11.873-.49.965.965 0 00.781.49l.127.001H22.75l.001-1.375a.75.75 0 00-.632-.74L22 8zm2.25 7.5h-3.625a2.625 2.625 0 100 5.25h3.625A.75.75 0 0025 20v-3.75a.75.75 0 00-.75-.75zm-3.375 1.813l.102.006a.813.813 0 11-.204 0l.102-.006z"}})])
          )
        }
      }
    